import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Icon } from "@mui/material";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const PRIMARY_COLOR = "#0070C2";

const StyledCard = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  "&:active": {
    transform: "translateY(0)",
  },
}));

function CustomCard({ icon: IconComponent, title, path, progessMessage }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (path) {
      navigate(`/${path}`);
    } else if (progessMessage) {
      toast.loading(progessMessage);
    }
  };
  const { t } = useTranslation();
  return (
    <StyledCard
      onClick={handleClick}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        textAlign: "left",
        backgroundColor: `${PRIMARY_COLOR}08`,
        border: `1px solid ${PRIMARY_COLOR}`,
        borderRadius: "8px",
        padding: "10px",
        gap: "16px",
        height: "100%",
        minHeight: "80px",
      }}
    >
      <Icon
        sx={{
          color: PRIMARY_COLOR,
          fontSize: "2.5rem",
          width: "2.5rem",
          height: "2.5rem",
          flexShrink: 0,
          transition: "transform 0.3s ease",
          ".MuiCard-root:hover &": {
            transform: "scale(1.1)",
          },
        }}
        className="!flex items-center justify-center"
      >
        <IconComponent style={{ width: "100%", height: "100%" }} />
      </Icon>
      <CardContent sx={{ padding: "0 !important" }}>
        <Typography
          component="div"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            transition: "color 0.3s ease",
            ".MuiCard-root:hover &": {
              color: PRIMARY_COLOR,
            },
          }}
        >
          {t(title)}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mt: 0.5,
            opacity: 0.8,
            fontSize: "0.875rem",
          }}
        >
          {t("Click to explore")}
        </Typography>
      </CardContent>
    </StyledCard>
  );
}

export default CustomCard;
